import React, { useState } from 'react';
import { useT } from './BuilderApp.jsx';

export default function SignInModal({ onClose, lang, setLang }) {
  const t = useT();
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const ok = email.includes('@') && pw.length >= 8;

  const handleSignIn = async () => {
    if (!ok) return;
    setBusy(true);
    // Mock auth — no backend
    await new Promise(r => setTimeout(r, 800));
    setBusy(false);
    onClose();
  };

  return (
    <div
      style={{position:'fixed',inset:0,zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{position:'absolute',inset:0,background:'rgba(5,10,20,.75)',backdropFilter:'blur(12px)'}}/>
      <div className="glass2" style={{position:'relative',zIndex:1,borderRadius:20,padding:'clamp(1.5rem,5vw,2.25rem)',width:'100%',maxWidth:420}}>
        <button
          onClick={onClose}
          style={{position:'absolute',top:'1rem',right:'1rem',background:'rgba(255,255,255,.08)',border:'1px solid var(--border2)',borderRadius:8,color:'var(--muted)',width:32,height:32,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:'1rem'}}
        >×</button>
        <div style={{textAlign:'center',marginBottom:'1.75rem'}}>
          <div style={{width:44,height:44,borderRadius:12,background:'linear-gradient(135deg,#2563eb,#7c3aed)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.25rem',margin:'0 auto .9rem'}}>⚡</div>
          <h2 style={{fontSize:'1.25rem',fontWeight:800,letterSpacing:'-.02em'}}>{t.signin_title}</h2>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:'1rem'}}>
          <div>
            <label className="field-label">{t.signin_email}</label>
            <input type="email" className="field-input" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)}/>
          </div>
          <div>
            <label className="field-label">{t.signin_pw}</label>
            <div style={{position:'relative'}}>
              <input
                type={showPw ? 'text' : 'password'}
                className="field-input"
                placeholder="••••••••"
                value={pw}
                onChange={e => setPw(e.target.value)}
                style={{paddingRight:'3.5rem'}}
                onKeyDown={e => { if (e.key === 'Enter') handleSignIn(); }}
              />
              <button
                type="button"
                onClick={() => setShowPw(v => !v)}
                style={{position:'absolute',right:'.8rem',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',color:'var(--muted)',cursor:'pointer',fontSize:'.78rem',padding:'.25rem'}}
              >
                {showPw ? t.s1_hide : t.s1_show}
              </button>
            </div>
          </div>
          <button
            className="btn btn-primary btn-lg btn-full"
            onClick={handleSignIn}
            disabled={!ok || busy}
            style={{marginTop:'.25rem'}}
          >
            {busy ? '…' : t.signin_btn}
          </button>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{fontSize:'.75rem',color:'var(--dim)',cursor:'pointer'}}>{t.signin_forgot}</span>
            <span style={{fontSize:'.75rem',color:'var(--dim)'}}>
              {t.signin_no_acct}{' '}
              <span style={{color:'var(--blue2)',cursor:'pointer'}} onClick={onClose}>{t.signin_start}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
